module.exports = {"news":{"title":"Een van meerdere projecten","read":"Meer lezen"},"how":{"title":"{service} is een emanciperend werktuig"}};